import React from 'react';
/**
 * Settings App
 * Theme switcher, language selector, and preferences
 */

import { Moon, Sun, Zap, Contrast, Globe } from 'lucide-react';
import { useTheme } from '../../core/contexts/ThemeContext';
import { Card } from '../ui/Card';
import { gradientPresets } from '../../core/constants/gradients';
export function SettingsApp() {
  const {
    theme,
    setTheme,
    language,
    setLanguage,
    background,
    setBackground,
    getThemeClasses
  } = useTheme();
  const themeClasses = getThemeClasses();
  const themes = [{
    id: 'dark',
    name: 'Dark',
    icon: Moon,
    color: 'from-slate-700 to-slate-900'
  }, {
    id: 'light',
    name: 'Light',
    icon: Sun,
    color: 'from-orange-300 to-yellow-300'
  }, {
    id: 'neon',
    name: 'Neon',
    icon: Zap,
    color: 'from-fuchsia-500 to-cyan-500'
  }, {
    id: 'highContrast',
    name: 'High Contrast',
    icon: Contrast,
    color: 'from-white to-black'
  }];
  return <div className={`p-8 ${themeClasses.text}`} data-id="element-481">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-482">
        {/* Theme Selector */}
        <section data-id="element-483">
          <h2 className="text-2xl font-bold mb-4" data-id="element-484">Thema</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-485">
            {themes.map(t => {
            const Icon = t.icon;
            const isActive = theme === t.id;
            return <button key={t.id} onClick={() => setTheme(t.id as any)} className={`
                    ${themeClasses.card}
                    rounded-xl p-6 transition-all
                    ${isActive ? 'ring-2 ring-white/40 scale-105' : 'hover:scale-105'}
                  `} data-id="element-486">
                  <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${t.color} flex items-center justify-center mb-3 mx-auto`} data-id="element-487">
                    <Icon className="w-6 h-6 text-white" data-id="element-488" />
                  </div>
                  <p className="text-sm font-medium" data-id="element-489">{t.name}</p>
                </button>;
          })}
          </div>
        </section>
        {/* Background Customizer (Light Theme Only) */}
        {theme === 'light' && <section data-id="element-490">
            <h2 className="text-2xl font-bold mb-4" data-id="element-491">Achtergrond</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-492">
              {gradientPresets.map(preset => <button key={preset.name} onClick={() => setBackground(preset.value)} className={`
                    ${preset.value}
                    h-24 rounded-xl border-2
                    ${background === preset.value ? 'border-purple-500 scale-105' : 'border-gray-300'}
                    transition-all hover:scale-105
                  `} data-id="element-493">
                  <div className="w-full h-full flex items-center justify-center bg-black/10 rounded-lg" data-id="element-494">
                    <span className="text-sm font-medium text-gray-900" data-id="element-495">
                      {preset.name}
                    </span>
                  </div>
                </button>)}
            </div>
          </section>}
        {/* Language Selector */}
        <section data-id="element-496">
          <h2 className="text-2xl font-bold mb-4" data-id="element-497">Taal / Language</h2>
          <div className="flex gap-4" data-id="element-498">
            <button onClick={() => setLanguage('nl')} className={`
                ${themeClasses.card}
                rounded-xl p-6 flex-1 transition-all
                ${language === 'nl' ? 'ring-2 ring-white/40 scale-105' : 'hover:scale-105'}
              `} data-id="element-499">
              <Globe className="w-8 h-8 mb-2 mx-auto" data-id="element-500" />
              <p className="font-medium" data-id="element-501">Nederlands</p>
            </button>
            <button onClick={() => setLanguage('en')} className={`
                ${themeClasses.card}
                rounded-xl p-6 flex-1 transition-all
                ${language === 'en' ? 'ring-2 ring-white/40 scale-105' : 'hover:scale-105'}
              `} data-id="element-502">
              <Globe className="w-8 h-8 mb-2 mx-auto" data-id="element-503" />
              <p className="font-medium" data-id="element-504">English</p>
            </button>
          </div>
        </section>
        {/* About Section */}
        <section className={`${themeClasses.card} rounded-xl p-6`} data-id="element-505">
          <h3 className="text-lg font-bold mb-2" data-id="element-506">MVL Creative OS</h3>
          <p className="text-sm opacity-80" data-id="element-507">Version 1.0.0</p>
          <p className="text-sm opacity-80 mt-4" data-id="element-508">
            Een macOS-geïnspireerd portfolio operating system gebouwd met React,
            TypeScript en Tailwind CSS.
          </p>
        </section>
      </div>
    </div>;
}